import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';
import { FullscreenComponent } from 'src/app/shared/components/fullscreen/fullscreen.component';

@Component({
    selector: 'app-iframe-fullscreen',
    templateUrl: './iframe-fullscreen.component.html',
    styleUrls: ['./iframe-fullscreen.component.scss'],
    standalone: false
})
export class IframeFullscreenComponent {
  @Input() public enableDownload = false;
  @Input() public enableFullscreen = false;
  @Input() public isFileDownloading = false;

  @Input() set url(value: string) {
    if (value) {
      this.urlSafe = value;
    }
  }

  @ViewChild(FullscreenComponent, {static: false}) fullscreenComponent: FullscreenComponent;

  @ViewChild('iframe', { static: false }) public set iframe(value: ElementRef) {
    if (value) {
      this._iframe = value;

      if (value.nativeElement.src !== this.urlSafe) {
        value.nativeElement.src = this.urlSafe;
      }
    }
  }

  public get iframe(): ElementRef {
    return this._iframe;
  }

  @Output() public fullscreenEnabled: EventEmitter<void> = new EventEmitter();
  @Output() public download: EventEmitter<void> = new EventEmitter();

  public urlSafe: SafeResourceUrl;

  private _iframe: ElementRef;

  constructor() { }


  public downloadFile(): void {
    this.download.emit();
  }

  public fullscreenToggle(): void {
    this.fullscreenEnabled.emit();
  }
}
